/**
 * It's a simple component which will called from GuidedNavigation
 *
 * @module views/components/ResultsHeader
 * @memberof -Common
 */
import './ResultsHeader.scss';

import React from 'react';

import PropTypes from 'prop-types';

import Text from '@ulta/core/components/Text/Text';

/**
 * Represents a ResultsHeader component
 *
 * @method
 * @param { ResultsHeaderProps} props - React properties passed from composition
 * @returns ResultsHeader
 */
export const ResultsHeader = function( props ){

  return (
    <div className='ResultsHeader'>
      <Text
        textStyle='title-6'
      >
        { props?.resultCountLabel }
      </Text>
    </div>
  );
};

/**
 * Property type definitions
 * @typedef ResultsHeaderProps
 * @type {object}
 * @property {string} resultCountLabel -  Sets the result count label for the page
 */
export const propTypes =  {
  resultCountLabel: PropTypes.string
};

ResultsHeader.propTypes = propTypes;

export default ResultsHeader;
